import { makeStyles } from "@material-ui/styles"

const style = makeStyles(theme => ({
  root: {
    margin: theme.spacing(2, 0),
    padding: theme.spacing(2, 4)
  },
  addEmailForm: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "flex-end"
  },
  tagsInput: {
    width: "100%"
  },
  addButton: {
    marginTop: theme.spacing(2)
  },
  listBox: {
    '& .MuiAutocomplete-option[aria-selected="true"]': {
      background: theme.palette.primary.main + "1D"
    }
  },
  popupIndicator: {
    color: "black !important"
  },

  rootTag: {
    backgroundColor: "#ADB4FF"
  }
}))

export default style



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Communication/CommunicationEmail/CommunicationNewEmail/styles.js